import type { InputProps, InputType } from '@/components/atomic/input-v2/types'

/**
 * Returns the appropriate formatting props based on input type
 */
export const getFormattingProps = (type: InputType, props: InputProps) => {
  const {
    thousandSeparator,
    decimalSeparator,
    decimalScale,
    fixedDecimalScale,
    allowNegative,
    allowLeadingZeros,
    prefix,
    suffix,
    format,
    mask,
    allowEmptyFormatting,
  } = props

  switch (type) {
    case 'currency':
      return {
        thousandSeparator: thousandSeparator ?? true,
        decimalSeparator: decimalSeparator ?? '.',
        decimalScale: decimalScale ?? 2,
        fixedDecimalScale: fixedDecimalScale ?? true,
        prefix: prefix || '$',
        suffix,
        allowNegative: allowNegative ?? true,
      }

    case 'number':
      return {
        thousandSeparator: thousandSeparator ?? false,
        decimalSeparator: decimalSeparator ?? '.',
        decimalScale,
        fixedDecimalScale: fixedDecimalScale ?? false,
        allowNegative: allowNegative ?? true,
        allowLeadingZeros: allowLeadingZeros ?? false,
        prefix: prefix ?? '',
        suffix: suffix ?? '',
      }

    case 'percentage':
      return {
        thousandSeparator: thousandSeparator ?? false,
        decimalSeparator: decimalSeparator ?? '.',
        decimalScale: decimalScale ?? 2,
        fixedDecimalScale: fixedDecimalScale ?? true,
        suffix: suffix || '%',
        allowNegative: allowNegative ?? true,
      }

    case 'custom':
      return {
        format: format as string,
        mask,
        allowEmptyFormatting: allowEmptyFormatting ?? false,
      }

    default:
      return {}
  }
}
